
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/widget/carousel",
      function () {
        return require("private-next-pages/blog/widget/carousel.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/widget/carousel"])
      });
    }
  